import { Box, Button, CircularProgress, FormControl, Grid, IconButton, InputAdornment, InputLabel, MenuItem, Paper, Select, styled, TextField, Typography } from '@mui/material';
import React, { useEffect, useState } from 'react'
import DriveFileRenameOutlineIcon from "@mui/icons-material/DriveFileRenameOutline";
import { DatePicker, LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { useTranslation } from 'react-i18next';
import dayjs from 'dayjs';
import useUserId from 'hooks/useUserId';
import colors from 'colors/color';
import edit_icon from '../../assets/img/edit_icon.svg';
import cancel_icon from '../../assets/img/cancel_icon.svg';
import opened_eye_icon from '../../assets/img/open_eye_icon.svg';
import closed_eye_icon from '../../assets/img/closed_eye_icon.svg';
import { NewSearchButton } from 'components/Buttons/Buttons';
const CancelButton = styled(Button)(({ theme }) => ({
    width: 115,
    height: 48,
    borderRadius: '10px',
    borderWidth: '1px',
    gap: '10px',
    paddingTop: '14px',
    paddingRight: '24px',
    paddingBottom: '14px',
    paddingLeft: '24px',

    border: '1px solid #FF0000',
    color: '#FF0000',
    "&:hover": {
        backgroundColor: "#FF0000",
        color: "#fff",
    },
}));
const UpdateButton = styled(Button)(({ theme }) => ({
    backgroundColor: "#fff",
    color: "#fff",
    boxShadow: "0px 0px 13px 4px rgba(0, 0, 0, 0.1)",
    "&:hover": {
        backgroundColor: "#303f9f",
        color: "#fff",
    },
}));
const StyledTextField = styled(TextField)(({ theme, isediting }) => ({
    "& .MuiOutlinedInput-root": {
        height: 56,
        borderRadius: "10px",
        fontFamily: "Poppins",
        borderColor: "#00000033",
        backgroundColor: "#fff",
        ...(isediting === "true" && {
            "& .MuiOutlinedInput-notchedOutline": {
                borderColor: "#e0e0e0",
            },
            "&:hover .MuiOutlinedInput-notchedOutline": {
                borderColor: "transparent",
                borderWidth: "2px",
                boxShadow: "0px 0px 5px 0.4px #0085FF",
            },
            "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                borderColor: "transparent",
                borderWidth: "2px",
                boxShadow: "0px 0px 5px 0.4px #0085FF",
            },
        }),
        ...(isediting === "false" && {
            backgroundColor: "#fff",
            "& .MuiOutlinedInput-notchedOutline": {
                borderColor: "#00000033",
            },
            "&:hover .MuiOutlinedInput-notchedOutline": {
                borderColor: "#00000033",
            },
            "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                borderColor: "transparent",
            },
        }),
    },
}));
const ProfileCard = styled(Paper)(({ theme }) => ({
    padding: theme.spacing(3),
    backgroundColor: "#fff",
    borderRadius: "15px",
    // boxShadow: "0 4px 50px #0000001A",
    width: "80%", // Change from fixed width to percentage
    margin: "0 auto", // Center the card horizontally
    maxWidth: "1200px", // Add maximum width for larger screens
}));
const StyledTypography = styled(Typography)(() => ({
    color: "#000",
    fontFamily: 'Poppins',
    fontWeight: 500,
    fontSize: '14px',
}));
const StyledSelect = styled(Select)(({ theme, isediting }) => ({
    height: 56,
    fontFamily: "Poppins",
    borderRadius: "10px",
    ...(isediting === "true" && {
        "& .MuiOutlinedInput-notchedOutline": {
            borderColor: "#e0e0e0",
        },
        "&:hover .MuiOutlinedInput-notchedOutline": {
            borderColor: "transparent",
            borderWidth: "2px",
            boxShadow: "0px 0px 5px 0.4px #0085FF",
        },
        "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
            borderColor: "transparent",
            borderWidth: "2px",
            boxShadow: "0px 0px 5px 0.4px #0085FF",
        },
    }),
    ...(isediting === "false" && {
        backgroundColor: "#fff",
        "& .MuiOutlinedInput-notchedOutline": {
            borderColor: "#00000033",
        },
        "&:hover .MuiOutlinedInput-notchedOutline": {
            borderColor: "#00000033",
        },
        "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
            borderColor: "transparent",
        },
    }),
    "& .MuiSelect-select": {
        padding: "16.5px 14px",
    },
}));
const StyledDatePicker = styled(DatePicker)(({ theme, isediting }) => ({
    "& .MuiOutlinedInput-root": {
        height: 56,
        borderRadius: "10px",
        fontFamily: "Poppins",
        ...(isediting === "true" && {
            "& .MuiOutlinedInput-notchedOutline": {
                borderColor: "#e0e0e0",
            },
            "&:hover .MuiOutlinedInput-notchedOutline": {
                borderColor: "transparent",
                borderWidth: "2px",
                boxShadow: "0px 0px 5px 0.4px #0085FF",
            },
            "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                borderColor: "transparent",
                borderWidth: "2px",
                boxShadow: "0px 0px 5px 0.4px #0085FF",
            },
        }),
        ...(isediting === "false" && {
            backgroundColor: "#fff",
            "& .MuiOutlinedInput-notchedOutline": {
                borderColor: "#00000033",
            },
            "&:hover .MuiOutlinedInput-notchedOutline": {
                borderColor: "#00000033",
            },
            "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                borderColor: "transparent",
            },
        }),
    },
}));

function PasswordSettings({ formData, setFormData }) {
    const { t } = useTranslation();
    const [isEditing, setIsEditing] = useState(false);
    const [loading, setLoading] = useState(false);
    const userId = useUserId();
    const user= userId.userId;
    const [isEditingBio, setIsEditingBio] = useState(false);
    const [alertMessage, setAlertMessage] = useState("");
    const [severity, setSeverity] = useState("success");
    const [snackbar, setSnackbar] = useState({
        open: false,
        message: "",
        severity: "info",
    });
    // useEffect(()=>{
    //     console.log('user-->', user)
    // },[user])

    // Add states for password visibility
    const [showCurrentPassword, setShowCurrentPassword] = useState(false);
    const [showNewPassword, setShowNewPassword] = useState(false);
    const [showConfirmPassword, setShowConfirmPassword] = useState(false);

    // Add states for password values
    const [passwordValues, setPasswordValues] = useState({
        currentPassword: "",
        newPassword: "",
        confirmPassword: ""
    });

    const showSnackbar = (message, severity = "info") => {
        setSnackbar({ open: true, message, severity });
    };

    const handleInputChange = (e) => {
        const { name, value } = e.target;

        // Handle password fields separately
        if (["currentPassword", "newPassword", "confirmPassword"].includes(name)) {
            setPasswordValues((prev) => ({
                ...prev,
                [name]: value,
            }));
        } else {
            setFormData((prev) => ({
                ...prev,
                [name]: value,
            }));
        }
    };

    const handleDateChange = (newValue) => {
        const validatedDate = newValue && dayjs.isDayjs(newValue) ? newValue : null;

        setFormData((prev) => ({
            ...prev,
            dateOfBirth: validatedDate,
        }));
    };

    const handleEdit = () => setIsEditing(true);

    // Toggle password visibility handlers
    const toggleCurrentPasswordVisibility = () => {
        setShowCurrentPassword(!showCurrentPassword);
    };

    const toggleNewPasswordVisibility = () => {
        setShowNewPassword(!showNewPassword);
    };

    const toggleConfirmPasswordVisibility = () => {
        setShowConfirmPassword(!showConfirmPassword);
    };

    const [authMethod, setAuthMethod] = useState(null);
    const [has_password, setHasPassword] = useState(false);
    const checkAuthMethod = async () => {
        const response = await fetch(
            `${process.env.REACT_APP_API_URL}authentication/check-auth-method/`,
            {
                method: "GET",
                headers: {
                    "Content-Type": "application/json",
                    Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
                }
            }
        )
        const data = await response.json();
        setAuthMethod(data.auth_method);
        setHasPassword(data.has_password);
    }
    useEffect(()=>{
        checkAuthMethod();
        console.log('has_password-->', has_password)
    },[])
    
    const handleSubmit = async (e, type = "profile") => {
        e.preventDefault();
        setLoading(true);

        try {
            const response = await fetch(
                `${process.env.REACT_APP_API_URL}authentication/change-password/`,
                {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json",
                        Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
                    },
                    body: JSON.stringify({
                        user: user,
                        old_password: passwordValues.currentPassword,
                        new_password: passwordValues.newPassword,
                        // confirm_password: passwordValues.confirmPassword,
                    }),
                }
            );

            if (response.ok) {
                showNotification(t("personalInformation.password_updated"));
                setIsEditing(false);
                setPasswordValues({
                    currentPassword: "",
                    newPassword: "",
                    confirmPassword: ""
                });
            } else {
                const errorData = await response.json();
                throw new Error(errorData.message || t("personalInformation.password_update_failed"));
            }
        } catch (error) {
            console.error("Error updating password:", error);
            showNotification(error.message || t("personalInformation.password_update_failed"), "error");
        } finally {
            setLoading(false);
        }
    };

    const showNotification = (message, severity = "success") => {
        setAlertMessage(message);
        setSeverity(severity);
        showSnackbar(message);
    };

    const handleCancel = () => {
        setIsEditing(false);
        // Reset password fields when cancelling
        setPasswordValues({
            currentPassword: "",
            newPassword: "",
            confirmPassword: ""
        });
    };

    console.log('Button disabled:', isEditing, authMethod, isEditing || (authMethod && authMethod.trim().toLowerCase() === 'social'));

    return (
        <div> <ProfileCard elevation={0}>
            {/* Profile Header */}
            <Box
                sx={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "flex-between",
                    mb: 4,
                }}
            >
                <Typography
                    variant="h6"
                    sx={{
                        fontFamily: 'Poppins',
                        fontWeight: 600,
                        fontSize: '32px',
                        color: colors.primary,
                        textTransform: 'none',
                    }}
                >
                    Password settings
                </Typography>

                <Button
                    variant="outlined"
                    onClick={handleEdit}
                    disabled={isEditing || !has_password}
                    sx={{
                        width: 135,
                        height: 48,
                        borderRadius: '10px',
                        gap: '10px',
                        paddingTop: '14px',
                        paddingRight: '20px',
                        paddingBottom: '14px',
                        paddingLeft: '20px',
                        backgroundColor: colors.primary,
                        "&:hover": {
                            border: "none",
                            backgroundColor: "rgba(26, 35, 126, 0.04)",
                            "& .MuiTypography-root": {
                                color: colors.primary,
                            },
                            "& img": {
                                filter: `brightness(0) saturate(100%) invert(23%) sepia(74%) saturate(1982%) hue-rotate(220deg) brightness(93%) contrast(98%)`
                            }
                        },
                        "&.Mui-disabled": {
                            bgcolor: "#e0e0e0",
                        },
                    }}
                >
                    <img src={edit_icon} alt="Edit" />
                    <Typography
                        sx={{
                            paddingLeft: 0,
                            fontFamily: 'Poppins',
                            fontWeight: 400,
                            fontSize: '12px',
                            textTransform: 'none',
                            color: 'white',
                        }}
                    >
                        {t("personalInformation.edit")}
                    </Typography>
                </Button>
            </Box>

            {/* Form Fields */}
            <Grid
                container
                columnSpacing={5}
                rowSpacing={6}
                sx={{
                    pl: 5,
                    pr: 5,
                }}
            >
                {/* Current Password */}
                <Grid item xs={12} spacing={5} sx={{ display: 'flex', alignItems: 'flex-start', gap: 8 }}>
                    <Grid item xs={3}>
                        <StyledTypography>
                            Current password
                        </StyledTypography>
                    </Grid>
                    <Grid item xs={4}>
                        <StyledTextField
                            disabled={!isEditing}
                            fullWidth
                            required
                            id="currentPassword"
                            name="currentPassword"
                            type={showCurrentPassword ? 'text' : 'password'}
                            value={passwordValues.currentPassword}
                            onChange={handleInputChange}
                            isediting={isEditing.toString()}
                            InputProps={{
                                endAdornment: (
                                    <InputAdornment position="end">
                                        <IconButton
                                            aria-label="toggle password visibility"
                                            onClick={toggleCurrentPasswordVisibility}
                                            edge="end"
                                            disabled={!isEditing}
                                            sx={{marginRight: 1,}}

                                        >
                                            <img
                                                src={showCurrentPassword ? opened_eye_icon : closed_eye_icon}
                                                alt={showCurrentPassword ? "Hide password" : "Show password"}
                                                // style={{ width: '15px', height: '15px', marginRight: 8 }}
                                                style={{
                                                    width: '15px',
                                                    height: '15px',
                                                    // marginRight: 8,
                                                    filter: !isEditing ? 'grayscale(100%)' : 'none',
                                                    opacity: !isEditing ? 0.5 : 1
                                                }}
                                            />
                                        </IconButton>
                                    </InputAdornment>
                                ),
                            }}
                        />
                    </Grid>
                </Grid>

                {/* New Password */}
                <Grid item xs={12} spacing={5} sx={{ display: 'flex', alignItems: 'flex-start', gap: 8 }}>
                    <Grid item xs={3}>
                        <StyledTypography>
                            New password
                        </StyledTypography>
                    </Grid>
                    <Grid item xs={4}>
                        <StyledTextField
                            disabled={!isEditing}
                            fullWidth
                            required
                            id="newPassword"
                            name="newPassword"
                            type={showNewPassword ? 'text' : 'password'}
                            value={passwordValues.newPassword}
                            onChange={handleInputChange}
                            isediting={isEditing.toString()}
                            InputProps={{
                                endAdornment: (
                                    <InputAdornment position="end">
                                        <IconButton
                                            aria-label="toggle password visibility"
                                            onClick={toggleNewPasswordVisibility}
                                            edge="end"
                                            disabled={!isEditing}
                                            sx={{marginRight: 1,}}
                                        >
                                            <img
                                                src={showNewPassword ? opened_eye_icon : closed_eye_icon}
                                                alt={showNewPassword ? "Hide password" : "Show password"}
                                                style={{
                                                    width: '15px',
                                                    height: '15px',
                                                    // marginRight: 8,
                                                    filter: !isEditing ? 'grayscale(100%)' : 'none',
                                                    opacity: !isEditing ? 0.5 : 1
                                                }}
                                            />
                                        </IconButton>
                                    </InputAdornment>
                                ),
                            }}
                        />
                    </Grid>
                </Grid>

                {/* Confirm New Password */}
                <Grid item xs={12} spacing={5} sx={{ display: 'flex', alignItems: 'flex-start', gap: 8 }}>
                    <Grid item xs={3}>
                        <StyledTypography>
                            Confirm new password
                        </StyledTypography>
                    </Grid>
                    <Grid item xs={4}>
                        <StyledTextField
                            disabled={!isEditing}
                            fullWidth
                            required
                            id="confirmPassword"
                            name="confirmPassword"
                            type={showConfirmPassword ? 'text' : 'password'}
                            value={passwordValues.confirmPassword}
                            onChange={handleInputChange}
                            isediting={isEditing.toString()}
                            InputProps={{
                                endAdornment: (
                                    <InputAdornment position="end">
                                        <IconButton
                                            aria-label="toggle password visibility"
                                            onClick={toggleConfirmPasswordVisibility}
                                            edge="end"
                                            disabled={!isEditing}
                                            sx={{marginRight: 1,}}
                                        >
                                            <img
                                                src={showConfirmPassword ? opened_eye_icon : closed_eye_icon}
                                                alt={showConfirmPassword ? "Hide password" : "Show password"}
                                                // style={{ width: '15px', height: '15px', marginRight: 8 }}
                                                style={{
                                                    width: '15px',
                                                    height: '15px',
                                                    // marginRight: 8,
                                                    filter: !isEditing ? 'grayscale(100%)' : 'none',
                                                    opacity: !isEditing ? 0.5 : 1
                                                }}
                                            />
                                        </IconButton>
                                    </InputAdornment>
                                ),
                            }}
                        />
                    </Grid>
                </Grid>
            </Grid>

            {/* Update Button */}
            {isEditing?(<Box sx={{ display: "flex", justifyContent: "flex-end", mt: 4, gap: 2 }}>
                <NewSearchButton
                    variant="contained"
                    onClick={handleSubmit}
                    disabled={!isEditing || loading}
                    // sx={{
                    //     bgcolor: "#fff",
                    //     color: "#004F98",
                    //     borderRadius: "10px",
                    //     textTransform: "none",
                    //     fontFamily: "Poppins",
                    //     px: 4,
                    //     py: 1,
                    //     fontWeight: "500px",
                    //     "&:hover": {
                    //         bgcolor: "#0085FF",
                    //     },
                    //     "&.Mui-disabled": {
                    //         bgcolor: "#e0e0e0",
                    //     },
                    // }}
                >
                    {loading ? (
                        <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                            <CircularProgress size={20} color="inherit" />
                            <span>{t("personalInformation.updating")}</span>
                        </Box>
                    ) : (
                        t("personalInformation.update_profile")
                    )}
                </NewSearchButton>

                <CancelButton
                    variant="contained"
                    onClick={handleCancel}
                    disabled={!isEditing || loading}
                    sx={{
                        bgcolor: "#fff",
                        color: "#004F98",
                        borderRadius: "10px",
                        textTransform: "none",
                        fontFamily: "Poppins",
                        px: 2,
                        py: 1,
                        fontWeight: "500",
                        "&:hover": {
                            bgcolor: "#FF0000",
                            "& .MuiTypography-root": {
                                color: "#FFFFFF",
                            },
                            "& img": {
                                filter: "brightness(0) invert(1)",
                            }
                        },
                        "&.Mui-disabled": {
                            bgcolor: "#e0e0e0",
                        },
                        "& .MuiTypography-root": {
                            color: "#FF0000",
                            fontFamily: "Poppins",
                            fontWeight: 400,
                            fontSize: "12px",
                        },
                    }}
                >
                    {loading ? (
                        <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                            <CircularProgress size={20} color="inherit" />
                            <span>{t("personalInformation.updating")}</span>
                        </Box>
                    ) : (
                        <>
                            <img src={cancel_icon} alt="Cancel" />
                            <Typography>
                                Cancel
                            </Typography>
                        </>
                    )}
                </CancelButton>
            </Box>):null}
            
        </ProfileCard> </div>
    )
}

export default PasswordSettings;